import React, { useEffect, useState } from "react";
import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import QuestionsForMeService from "../../services/QuestionsForMeService";
import PropTypes from "prop-types";
import DataCards2 from "../../common/DataCards2/DataCards2";
import { getFromEncLocalStorage } from "../../helpers/Utils/Utils";

function QuestionsForMe(props) {
  const [isLoading, setLoading] = useState(false);
  const [questionsForMe, setQuestionsForMe] = useState([]);
  const [ismore, setMore] = useState(true);

  useEffect(() => {
    getquestionsForMe(1);
  }, []);

  const getquestionsForMe = async (page) => {
    let scrollPosition = getFromEncLocalStorage("position");
    setLoading(true);
    let reqBody = {
      limit: 10,
      pageNo: page,
    };
    const res = await QuestionsForMeService.questionsForMe(reqBody);

    if (res) {
      if (res.length < 10) {
        setMore(false);
      }
      let data = [...questionsForMe, ...res];
      setQuestionsForMe(data);
    }
    if (props.location.state != undefined) {
      window.scrollTo(0, scrollPosition);
    }
    setLoading(false);
  };

  const rerender = (val) => {
    getquestionsForMe(val);
  };

  return (
    <Main active={"questions_for_me"}>
      <Loadspinner filename="QuestionsForMe.js" isLoading={isLoading} isMiddle="true" />
      <DataCards2
        dataList={questionsForMe}
        rerenderParentCallback={rerender}
        ismore={ismore}
      />
    </Main>
  );
}

export default QuestionsForMe;

QuestionsForMe.propTypes = {
  location: PropTypes.object,
};
